"use client"

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { Kbd } from '../ui/kbd'
import { useCallback, useEffect, useState } from 'react'
import { RecoveryView } from '@/app/deployment/recovery/page'
import Dropdown, { dropdownCss, DropdownInterface } from '../ui/dropdown'
import RecoveryModal from './RecoveryModal'
import { getAllDomains } from '@/services/domains.service'
import { GetBackups } from '@/services/backup.service'
import { getApprovedConnections } from '@/services/ftpConnections.service'

interface Props {
    domains: RecoveryView[]
}

export default function RecoveryTable(props: Props) {
    const [currentDomains, setCurrentDomains] = useState<RecoveryView[]>([]);
    const [approvedConnections, setApprovedConnections] = useState<DropdownInterface[]>([]);

    const updateDomains = async () => {
        const domains = await getAllDomains();
        const backupsResult = await GetBackups();
        const arr = domains.map(d => {
            const backups: DropdownInterface[] = backupsResult.filter(backups => backups.DomainId == d.ID).map((backups, index) => {
                return {id: index, value:backups.BackupName, text:backups.BackupName};
            });
        
            const recoveryView: RecoveryView = {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, Backups: backups, RecoveryStatus: false};
            return recoveryView
        });
        setCurrentDomains(arr);
    }

    const loadAllApprovedConnections = useCallback(async () => {
        const approvedConnectionsResult: DropdownInterface[] = (await getApprovedConnections()).map((connection) => {
          return {id: Number(connection.ID), value: connection.ID, text: connection.Name};
        });
        setApprovedConnections(approvedConnectionsResult);
    }, []);

    useEffect(() => {
        if(currentDomains.length === 0) {
            setCurrentDomains(props.domains);
        }
    }, [currentDomains, props.domains]);

    useEffect(() => {
        if (approvedConnections.length === 0) {
            loadAllApprovedConnections();
        }
    }, [approvedConnections.length, loadAllApprovedConnections]);

    return <div>
        <h1 className="text-xl font-bold text-black dark:text-white mb-2">
            Recovery
        </h1>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>#</TableHead>
                    <TableHead>Navn / database</TableHead>
                    <TableHead>Website / mappe</TableHead>
                    <TableHead>Pakke</TableHead>
                    <TableHead>Backups</TableHead>
                    <TableHead>Recover</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {currentDomains?.map((domain, _index) => (
                    <TableRow key={domain.ID}>
                        <TableCell>{domain.ID}</TableCell>
                        <TableCell>{domain.Name} <Kbd>{domain.DBRel}</Kbd></TableCell>
                        <TableCell>{domain.Website} <Kbd>{domain.Folder}</Kbd></TableCell>
                        <TableCell>{domain.Package}</TableCell>
                        <TableCell>
                            <Dropdown
                                id={"recovery-" + domain.ID}
                                title=''
                                className={dropdownCss}
                            >
                                {domain.Backups}
                            </Dropdown>
                        </TableCell>
                        <TableCell>
                            <RecoveryModal
                                domain={domain}
                                updateData={updateDomains}
                                approvedConnections={approvedConnections}
                            />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </div> 
}